import { navItems } from '../Types';

export const homeItems : navItems =  [{
      title: "Home",
      href: "/",
      value: "Home",
      icon: "mdi-home",
    },
    {    
      title: "About",
      href: "/about",
      value: "About",
      icon: "mdi-information-variant",
    },
    {    
      title: "ThaiFRAT",
      href: "/thaifrat",
      value: "About",
      icon: "mdi-form-select",
    },
    // {    
    //   title: "Logout",
    //   href: "/Logout",
    //   value: "Logout",
    //   icon: "mdi-logout",
    // },
  ]


// const aboutItems : navItems =  {    
//       title: "About",
//       link: "/about",
//       value: "About",
//     }

